import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// The B2C sign-in popup comes back to our redirectUri with the response in the URL hash; the
// page that opened it reads that hash and closes the popup. Starting the app there would
// rewrite the URL first (/ → /home?lang=…) and the sign-in fails with hash_empty_error (WI 4623).
const isSignInPopup = !!window.opener && /[#&](code|error)=/.test(window.location.hash);

if (!isSignInPopup) {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
}
